import {
  DesktopArtifactArch,
  DesktopArtifactPlatform,
  DesktopDistribution,
} from "@packages/global";
import type { DesktopDownloadTarget } from "../../services/desktop-release.api";

export const DOWNLOAD_TARGETS: DesktopDownloadTarget[] = [
  { platform: DesktopArtifactPlatform.WINDOWS, arch: DesktopArtifactArch.X64, distribution: DesktopDistribution.INSTALLER },
  { platform: DesktopArtifactPlatform.WINDOWS, arch: DesktopArtifactArch.X64, distribution: DesktopDistribution.PORTABLE },
  { platform: DesktopArtifactPlatform.WINDOWS, arch: DesktopArtifactArch.ARM64, distribution: DesktopDistribution.INSTALLER },
  { platform: DesktopArtifactPlatform.WINDOWS, arch: DesktopArtifactArch.ARM64, distribution: DesktopDistribution.PORTABLE },
  { platform: DesktopArtifactPlatform.MACOS, arch: DesktopArtifactArch.UNIVERSAL, distribution: DesktopDistribution.INSTALLER },
  { platform: DesktopArtifactPlatform.MACOS, arch: DesktopArtifactArch.UNIVERSAL, distribution: DesktopDistribution.PORTABLE },
  { platform: DesktopArtifactPlatform.MACOS, arch: DesktopArtifactArch.ARM64, distribution: DesktopDistribution.INSTALLER },
  { platform: DesktopArtifactPlatform.MACOS, arch: DesktopArtifactArch.ARM64, distribution: DesktopDistribution.PORTABLE },
  { platform: DesktopArtifactPlatform.MACOS, arch: DesktopArtifactArch.X64, distribution: DesktopDistribution.INSTALLER },
  { platform: DesktopArtifactPlatform.MACOS, arch: DesktopArtifactArch.X64, distribution: DesktopDistribution.PORTABLE },
];
